import { getCustomer } from "@/graphql/schemas/shared/utils/getCustomer"

import { checkPermissions, validateAccessRightsToCustomer } from "../../shared/permissions/permissions"
import { DomainObjects, Operations } from "../../shared/permissions/permissionsConfig"
import { updateCustomerCart } from "../utils/cartHelpers"
import { getActiveCustomerCart } from "../utils/getCart"

export const mutationResetCartShippingAddress = {
  async resetCartShippingAddress(_parent, args, context, _info) {
    const { customerId, customerNumber } = args
    const { user } = context

    await checkPermissions({
      user,
      domainObject: DomainObjects.CARTS,
      operation: Operations.UPDATE,
    })

    const customer = await getCustomer({ id: customerId, number: customerNumber })

    if (!customer) {
      throw new Error("Customer not found")
    }

    await validateAccessRightsToCustomer({
      user: user,
      customerNumber: customer.customerNumber,
    })

    const customerCarts = await getActiveCustomerCart(customer.id, user.employeeNumber)
    let customerCart = customerCarts[0]

    if (!customerCart || customerCart.cartState !== "Active") {
      throw new Error("Customer does not have an active cart")
    }

    const addresses = Object.fromEntries(customer.addresses.map((address) => [address.id, address]))
    const defaultShippingAddress =
      addresses[customer.defaultShippingAddressId] || addresses[customer.defaultBillingAddressId]

    if (!defaultShippingAddress) {
      throw new Error("No default shipping address found for customer")
    }

    const addressAction = {
      action: "setShippingAddress",
      address: {
        firstName: defaultShippingAddress.firstName,
        lastName: defaultShippingAddress.lastName,
        streetName: defaultShippingAddress.streetName,
        additionalStreetInfo: defaultShippingAddress.additionalStreetInfo,
        city: defaultShippingAddress.city,
        postalCode: defaultShippingAddress.postalCode,
        country: defaultShippingAddress.country,
        ...(defaultShippingAddress.company && { company: defaultShippingAddress.company }),
        ...(defaultShippingAddress.phone && { phone: defaultShippingAddress.phone }),
        ...(defaultShippingAddress.email && { email: defaultShippingAddress.email }),
      },
    }

    const updatedCart = await updateCustomerCart({
      customerCart,
      actions: [addressAction],
    })

    return updatedCart
  },
}
